import React from 'react';
import Row from './Row';
import Pagination from 'Components/Pagination';
import RowsSelector from 'Components/RowsSelector';
import FiltersSection from './FiltersSection';
import TableHeader from './TableHeader';
import EmptyList from 'Components/EmptyList';
import {Input, inputStyleClasses} from 'Components/Input';

const SEARCHABLE_FIELDS = ['id', 'description'];

export default class List extends React.Component {
  defaultState = {
    activePage: 1,
    selectedRowsCount: 10,
    sortedBy: 'id',
    sortAsc: -1,
    filter: {},
    searchString: '',
  };

  constructor(props) {
    super(props);

    const storedState = props.user.getStoredState('listState', this.defaultState);
    if (!props.user.isInternal() && storedState.filter) delete storedState.filter.submissionDate;
    props.user.updateURLSearchString(storedState);

    this.state = {
      ...this.defaultState,
      ...storedState,
    };

    // NMMA-3004
    // if (props.user.getSelectedYear()) {
    // this.state.filter.submissionDate = props.user.getSelectedYear();
    // }

    if (!props.user.isInternal()) delete this.state.filter.submissionDate;
  }

  componentWillUnmount() {
    const { user } = this.props;

    user.saveState('listState', this.state, ['submissionDate']);
  }

  handleRowsSelect = (rowsCountSelected, totalRowsCount) => {
    const { user } = this.props;

    const selectedRowsCount = rowsCountSelected && rowsCountSelected < totalRowsCount ? rowsCountSelected : 0;

    const state = { selectedRowsCount, activePage: 1 };
    this.setState(state, user.updateURLSearchString(state));
  };

  _handleActivePageChange = activePage => {
    const { user } = this.props;

    this.setState({ activePage }, () => {
      user.updateURLSearchString({ activePage });
    });
  };

  _sortList = (a, b) => {
    const { sortedBy, sortAsc } = this.state;

    switch (sortedBy) {
      case 'id':
        return +a.id > +b.id ? sortAsc : -sortAsc;
      case 'componentType':
        return a.componentType.componentTypeName.toLowerCase() > b.componentType.componentTypeName.toLowerCase()
          ? sortAsc
          : -sortAsc;
      default:
        return (a[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ') >
          (b[sortedBy] || ' ').toString().toLowerCase().replace(/\s+/g, ' ')
          ? sortAsc
          : -sortAsc;
    }
  };

  handleSort = sortedBy => () => {
    const { user } = this.props;

    this.setState(
      prevState => ({ sortedBy, sortAsc: -prevState.sortAsc, activePage: 1 }),
      () => {
        user.updateURLSearchString({ sortedBy: this.state.sortedBy, sortAsc: this.state.sortAsc, activePage: 1 });
      }
    );
  };

  _filterList = componentList => {
    const { filter, searchString } = this.state;

    const doesSearchableFieldsContainSearchString = element => {
      for (let searchableFieldIndex in SEARCHABLE_FIELDS) {
        if (element[SEARCHABLE_FIELDS[searchableFieldIndex]]) {
          if (
            element[SEARCHABLE_FIELDS[searchableFieldIndex]]
              .toString()
              .toLowerCase()
              .includes(searchString.toLowerCase())
          )
            return true;
        }
      }
      return false;
    };

    return componentList.filter(element => {
      for (let filterFieldName in filter) {
        switch (filterFieldName) {
          case 'categoryId':
            if (element.componentType[filterFieldName] !== filter[filterFieldName]) {
              return false;
            }
            break;
          case 'componentType':
            if (element[filterFieldName].componentTypeCode !== filter[filterFieldName]) {
              return false;
            }
            break;
          case 'applicationStatus':
            if (element[filterFieldName].toLowerCase() !== filter[filterFieldName].toLowerCase()) {
              return false;
            }
            break;
          case 'submissionDate':
            if (new Date(element.submissionDate).getFullYear() !== filter[filterFieldName]) {
              return false;
            }
            break;
          default:
            if (element[filterFieldName] !== filter[filterFieldName]) {
              return false;
            }
        }
      }
      return !searchString || doesSearchableFieldsContainSearchString(element);
    });
  };

  handleSearchStringInput = value => {
    const { user } = this.props;
    this.setState({ searchString: value, activePage: 1 }, () => {
      user.updateURLSearchString({ searchString: value });
    });
  };

  handleSelectFilter = filterFieldName => filterElement => {
    const { user } = this.props;
    const newFilterFieldValue = filterElement.value !== undefined ? filterElement.value : filterElement;
    let newFilterState = this.state.filter;

    if (newFilterFieldValue === 'All') delete newFilterState[filterFieldName];
    else newFilterState[filterFieldName] = newFilterFieldValue;

    if (filterFieldName === 'categoryId') delete newFilterState.componentType;

    if (filterFieldName === 'submissionDate') {
      if (filterElement === 'All') {
        user.saveSelectedYear('');
      } else {
        user.saveSelectedYear(filterElement);
      }
    }

    this.setState({ filter: newFilterState, activePage: 1 }, () => {
      user.updateURLSearchString({ filter: this.state.filter, activePage: 1 });
    });
  };

  _getList = () => {
    const { activePage, selectedRowsCount, sortedBy } = this.state;
    const {
      user,
      createAvailableForThisStatusActionsList,
      performActionFunction,
      components,
      componentsRequestInProcess,
      updateComponentListEntry,
    } = this.props;

    let resultList = [];
    let resultLength = 0;

    if (!components.length) {
      if (componentsRequestInProcess) {
        resultList = [
          <div key="spinner" className='ect-spinner _height_120'>
            <div className='ect-spinner__image' style={{ width: 50, height: 50 }} />
          </div>,
        ];
      } else {
        resultList = [<EmptyList key="empty">No components for selected manufacturer.</EmptyList>];
      }
    } else {
      const filteredList = this._filterList(components).sort(this._sortList);
      const sliceFrom = (activePage - 1) * selectedRowsCount;
      const sliceTo = +selectedRowsCount ? activePage * selectedRowsCount : filteredList.length;

      if (!filteredList.length) {
        resultList = [<EmptyList key="empty">No components found with selected filters.</EmptyList>];
      } else {
        resultList = filteredList.slice(sliceFrom, sliceTo).map((component, index) => {
          return (
            <Row
              key={component.id}
              user={user}
              sortedBy={sortedBy}
              component={component}
              isOdd={!!(index % 2)}
              availableActionsList={createAvailableForThisStatusActionsList(component.applicationStatus)}
              performActionFunction={performActionFunction}
              updateComponentListEntry={updateComponentListEntry}
            />
          );
        });
        resultLength = filteredList.length;
      }
    }

    return {
      resultList,
      resultLength,
    };
  };

  render() {
    const { types, categories, user, currentModelYear } = this.props;
    const { activePage, selectedRowsCount, filter, sortedBy, sortAsc, searchString } = this.state;
    const { resultList, resultLength } = this._getList();

    return (
      <section className='scene__scene-wrapper'>
        <section className='scene__content-wrapper list-scene__content-wrapper'>
          <header className='scene__scene-header list-scene__scene-header'>
            Component List
            <Input
              mainWrapperClassName='list-scene__header-search-field-wrapper'
              styleClass={inputStyleClasses.searchBar}
              placeholder='Type here to search'
              maxLength={250}
              value={searchString}
              onChange={this.handleSearchStringInput}
            />
          </header>

          <FiltersSection
            outCount={resultLength}
            handleRowsSelect={this.handleRowsSelect}
            rowsCount={selectedRowsCount}
            handleSelectFilter={this.handleSelectFilter}
            filterState={filter}
            types={types}
            categories={categories}
            currentModelYear={currentModelYear}
            user={user}
          />

          <TableHeader handleSortClick={this.handleSort} order={sortAsc === 1} sortedBy={sortedBy} />

          {resultList}

          <footer className='list-scene__footer'>
            <RowsSelector
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
              handleRowsSelect={this.handleRowsSelect}
            />
            <Pagination
              className='_height_80'
              activePage={activePage}
              handleClick={this._handleActivePageChange}
              allRowsCount={resultLength}
              selectedRowsCount={selectedRowsCount}
            />
          </footer>
        </section>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/app/Scenes/ComponentManufacturer/List/index.jsx